export default class Meridian {
    id?: number;
    name: string;
    isPrimary: boolean;
}



// WEBPACK FOOTER //
// ./src/models/Meridian.ts